import React from "react";
import Representation from './Representation';

const DatePicker = (props) => {
  return <Representation
    {...props}
  />
}

export default DatePicker;